import { MastraClient } from "@mastra/client-js";
import cookie from "react-cookies";

export const mastraClient = new MastraClient({
    baseUrl: import.meta.env.VITE_CINDRA_AGENT_URL || "http://localhost:4111"
});

// Agent ID type
export type AgentId = "cindra-claude" | "cindra-gemini" | "cindra-gpt";

// LLM ID type
export type LLMId = "claude-haiku-4-5" | "claude-sonnet-4-5-20250929" | "gemini-3-pro-preview" | "gpt-5.1";

// Cookie key for storing LLM selection
const LLM_SELECTION_COOKIE_KEY = "cindra_selected_llm";

// Default LLM ID
const DEFAULT_LLM_ID: LLMId = "claude-haiku-4-5";

// Agent mapping
const agentMap: Partial<Record<LLMId, AgentId>> = {
    "claude-haiku-4-5": "cindra-claude",
    // "gemini-3-pro-preview": "cindra-gemini",
    // "gpt-5.1": "cindra-gpt",
};

// Function to get agent based on selected LLM
export const getAgentForLLM = (llmId: LLMId) => {
    const agentName = agentMap[llmId] || agentMap[DEFAULT_LLM_ID];
    return mastraClient.getAgent(agentName);
};

// Function to get the currently selected LLM ID from cookies
export const getSelectedLLM = (): LLMId => {
    const savedLLM = cookie.load(LLM_SELECTION_COOKIE_KEY) as LLMId | undefined;
    return savedLLM && agentMap[savedLLM] ? savedLLM : DEFAULT_LLM_ID;
};

// Function to save the selected LLM ID to cookies
export const setSelectedLLM = (llmId: LLMId): void => {
    // Save cookie with 1 year expiration
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);
    cookie.save(LLM_SELECTION_COOKIE_KEY, llmId, { path: "/", expires });
};

// Function to get the currently selected agent
export const getSelectedAgent = () => {
    const llmId = getSelectedLLM();
    return getAgentForLLM(llmId);
};
